// extracted by mini-css-extract-plugin
export default {"Actions":"_Actions--LHPJZ","Active":"_Active--dsSlv","MenuItem":"_MenuItem--SBrye","DeleteMenuItem":"_DeleteMenuItem--pVj8k","Delete":"_Delete--xLKYX"};